import styles from './../../../../../MaskOverlay.module.scss';

import { Box, Theme, useMediaQuery } from '@mui/material';
import clsx from 'clsx';
import { useEffect, useMemo, useRef, useState } from 'react';
import { TableInstance } from 'react-table';

import { useDialogs } from '@work4all/components';
import { ResizableArea } from '@work4all/components/lib/components/ResizableArea';

import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { EntityPreview } from '../../../../../../../../components/data-tables/entity-table/EntityPreview';
import { Panel } from '../../../../../components';
import { IEditTable } from '../../../../erp/components/tab-panels/positions/components/edit-table/types';

import { AssignmentContent } from './AssignmentContent';
import { DescriptionContent } from './DescriptionContent';
import { CheckListPositionsTableContent } from './positions-table';
import { useCheckListPositionsState } from './positions-table/hooks';

export const CheckListOverlayControllerGeneralTabContent = () => {
  const editTableRef = useRef<IEditTable>(null);
  const tableInstanceRef = useRef<TableInstance>(null);
  const state = useCheckListPositionsState({ editTableRef });
  const entityPreviewProps = useMemo(() => {
    if (!state.selectedPosition) {
      return null;
    }

    if (state.selectedPosition.task) {
      return {
        entries: [state.selectedPosition.task],
        entityType: Entities.task,
      };
    }

    if (state.selectedPosition.ticket) {
      return {
        entries: [state.selectedPosition.ticket],
        entityType: Entities.ticket,
      };
    }

    return null;
  }, [state.selectedPosition]);

  const [entityPreviewWidth, setEntityPreviewWidth] = useState(400);

  const dialogs = useDialogs();
  const isDesktop = useMediaQuery<Theme>((theme) => theme.breakpoints.up('xl'));

  useEffect(() => {
    if (!entityPreviewProps || isDesktop) return;

    const dialog = dialogs.overlay(
      <EntityPreview
        {...entityPreviewProps}
        onCloseClick={() => {
          dialogs.close(dialog.id);
          tableInstanceRef.current.toggleAllRowsSelected(false);
        }}
      />
    );
  }, [dialogs, entityPreviewProps, isDesktop]);

  return (
    <Box display="grid" gridTemplateColumns="auto auto">
      <Panel
        className={clsx(
          styles.scrollablePanel,
          styles.shrink,
          styles.overflowXHidden
        )}
      >
        <DescriptionContent />
        <AssignmentContent />
        <CheckListPositionsTableContent
          tableInstanceRef={tableInstanceRef}
          editTableRef={editTableRef}
          state={state}
        />
      </Panel>

      {isDesktop && entityPreviewProps && (
        <ResizableArea
          direction="horizontal"
          size={{ width: entityPreviewWidth }}
          handles="left"
          minWidth={400}
          maxWidth={600}
          onResize={(e) => {
            setEntityPreviewWidth(e.width);
          }}
        >
          <Box height="calc(100vh - 100px)">
            <EntityPreview
              {...entityPreviewProps}
              onCloseClick={() => {
                tableInstanceRef.current.toggleAllRowsSelected(false);
              }}
            />
          </Box>
        </ResizableArea>
      )}
    </Box>
  );
};
